// warmup.ts
import axios from "axios";

const warmClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 5000,
});

export const warmUpApi = async () => {
    try {
        await warmClient.get("health");
    } catch {
        // ignore;
    }
};

export const warmUpSql = async () => {
    try {
        await warmClient.get("health/select");
    } catch {
        // ignore;
    }
};
